import React from 'react';
import { EarIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import type { AccessKey } from '../../types/demo';
import { Dialog } from './Dialog';
import { Button } from '../story/Button';
const SETTINGS: {
  key: AccessKey;
  label: string;
  description: string;
}[] = [{
  key: 'quietView',
  label: 'Quiet view',
  description: 'Simple text cards and a still background instead of drawn scenes. Every clue and choice stays.'
}, {
  key: 'reducedMotion',
  label: 'Reduced motion',
  description: 'No drifting fog, moving water, or growing roots. Changes appear still.'
}, {
  key: 'highContrast',
  label: 'High contrast',
  description: 'Stronger outlines and darker text.'
}, {
  key: 'largerText',
  label: 'Larger text',
  description: 'Bigger text across the whole demo.'
}];
export function AccessSettingsDialog() {
  const {
    state,
    dispatch,
    dialog,
    closeDialog,
    announce
  } = useDemo();
  return <Dialog open={dialog === 'settings'} onClose={closeDialog} id="access-settings" title="Choose how to play" data-id="element-377" data-mp="12122pwfhyyv5">
      <ul className="flex flex-col gap-3" data-id="element-378" data-mp="3khjbqhvm10n5">
        {SETTINGS.map(setting => {
        const on = state.accessPreferences[setting.key];
        return <li key={setting.key} className="flex items-start justify-between gap-4 rounded-xl border border-line p-4 hc-strong" data-id="element-379" data-mp="3bhw95sr59osi">
              <div data-id="element-380" data-mp="3fmcbxl5gog3i">
                <p id={`setting-${setting.key}`} className="font-bold text-forest" data-id="element-381" data-mp="31suqtvx4mvbd">
                  {setting.label}
                </p>
                <p className="text-sm text-ink/80" data-id="element-382" data-mp="36kmjcbzufb45">{setting.description}</p>
              </div>
              <button type="button" role="switch" aria-checked={on} aria-labelledby={`setting-${setting.key}`} onClick={() => {
            dispatch({
              type: 'SET_ACCESS',
              key: setting.key,
              value: !on
            });
            announce(`${setting.label} ${on ? 'off' : 'on'}.`);
          }} className={`inline-flex min-h-[44px] min-w-[76px] shrink-0 items-center justify-center rounded-full border px-3 text-sm font-bold transition-colors duration-150 hc-strong ${on ? 'border-teal bg-teal text-cream' : 'border-line bg-cream text-forest'}`} data-id="element-383" data-mp="2rvq33rnmursg">
                {on ? 'On' : 'Off'}
              </button>
            </li>;
      })}
      </ul>
      <div className="mt-5 flex items-start gap-2 rounded-xl bg-sand p-4" data-id="element-384" data-mp="1cao76e257vyv">
        <EarIcon size={20} className="mt-0.5 shrink-0 text-teal" aria-hidden="true" data-id="element-385" data-mp="17c4k2abtce4x" />
        <p data-id="element-386" data-mp="13asprrhzv4qe">This demo uses written sound cues. No headphones needed.</p>
      </div>
      <p className="mt-3 text-sm text-ink/80" data-id="element-387" data-mp="13cvpj38y8c8b">There is no timer anywhere. Nothing moves on by itself.</p>
      <div className="mt-5 flex justify-end" data-id="element-388" data-mp="year99d9c2mi">
        <Button onClick={closeDialog} data-id="element-389" data-mp="3o2b9be9r30og">Done</Button>
      </div>
    </Dialog>;
}